module.exports = __webpack_public_path__ + "static/workers.c7f8373f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/workers.jpeg
// module id = ./src/themes/workers.jpeg
// module chunks = 35783957827783 156897593687669